module.exports = __webpack_public_path__ + "static/media/andrei_cristian_danila.fba1b6ae.png";